import { render, staticRenderFns } from "./RunInfos.vue?vue&type=template&id=9b722c9c&scoped=true&"
import script from "./RunInfos.vue?vue&type=script&lang=js&"
export * from "./RunInfos.vue?vue&type=script&lang=js&"
import style0 from "./RunInfos.vue?vue&type=style&index=0&id=9b722c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b722c9c",
  null
  
)

export default component.exports